import {SetupAnalytics} from '@macmillanplatform/ui-core/utils';

import {env} from '../config';
import {GOOGLE_ANALYTICS_CODES} from '../constants';

const [GoogleAnalytics, pageAnalytics] = SetupAnalytics(GOOGLE_ANALYTICS_CODES[env]);
if (process.env.NODE_ENV !== 'test') GoogleAnalytics.init();

export {pageAnalytics};
export default GoogleAnalytics;
